import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { UserRequestBody, UserResponse } from "./types";

export class UserAPI extends BaseAPI<UserRequestBody, UserResponse> {
  protected route = ApiRoutes.auth.user;
  protected method = RequestMethod.GET;
}
